<template>
  <div class="cjr">
    <div v-if="loading" class="text-center text-primary py-1">
      <b-spinner small class="mr-50"/>{{ msg('Loading') }}...
    </div>

    <template v-else>
      <!-- which journey applies to this reservation -->
      <div class="cjr-head">
        <div>
          <span class="cjr-head__journey">
            <feather-icon icon="MapIcon" size="14" class="mr-25"/>
            {{ resolvedName || msg('nojourneyforbooking') }}
          </span>
          <b-badge v-if="response" :variant="response.status === 'SUBMITTED' ? 'light-success' : 'light-warning'"
                   class="ml-50">
            {{ msg(response.status === 'SUBMITTED' ? 'submitted' : 'draft') }}
          </b-badge>
          <b-badge v-else-if="resolvedName" variant="light-secondary" class="ml-50">
            {{ msg('notstarted') }}
          </b-badge>
        </div>
        <b-button v-if="responses.length > 1" variant="flat-secondary" size="sm" @click="cycle">
          <feather-icon icon="ChevronRightIcon" size="14"/>
        </b-button>
      </div>

      <journey-response-detail v-if="response" :response="response" class="mt-1"/>

      <div v-else class="cjr-empty">
        {{ resolvedName ? msg('journeynotansweredyet') : msg('journeynotargethint') }}
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import JourneyResponseDetail from '@/components/panels/journey/journeyResponseDetail.vue'

/** Guest Journey section on the reservation page. */
export default {
  name: 'contractJourneyResponse',
  components: {JourneyResponseDetail},
  props: {
    contractId: {type: String, required: true},
  },
  data() {
    return {
      loading: true,
      responses: [],
      index: 0,
      resolvedName: null,
    }
  },
  computed: {
    ...mapGetters('translator', ['msg']),
    response() {
      return this.responses.length ? this.responses[this.index % this.responses.length] : null;
    },
  },
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      const $this = this;
      this.loading = true;
      this.$store.dispatch('journey/getResponsesByContract', this.contractId)
          .then(list => {
            $this.responses = list || [];
            if ($this.responses.length) $this.resolvedName = $this.responses[0].journeyName;
          })
          .catch(() => {
            $this.responses = [];
          })
          .finally(() => {
            $this.loading = false;
            if (!$this.responses.length) $this.resolve();
            else $this.emitState();
          });
    },
    /** no response yet -> show which journey this booking would get */
    resolve() {
      const $this = this;
      this.$store.dispatch('journey/resolveForContract', this.contractId)
          .then(ans => {
            const journey = ans && ans['Journey'];
            $this.resolvedName = journey ? journey.name : null;
          })
          .catch(() => {
          })
          .finally(() => $this.emitState());
    },
    /** journey progress + upsell order info for the page: null status = not started */
    emitState() {
      const response = this.response;
      let productsCount = 0;
      if (response != null && Array.isArray(response.answers)) {
        response.answers.forEach(answer => {
          (answer.products || []).forEach(product => {
            if (product != null && !product.skippedReason) productsCount++;
          });
        });
      }
      this.$emit('state', {
        status: response ? response.status : null,
        name: this.resolvedName,
        orderId: response ? response.orderId : null,
        totalUpsellValue: response ? response.totalUpsellValue : null,
        currency: response ? response.currency : null,
        productsCount,
      });
    },
    cycle() {
      this.index = (this.index + 1) % this.responses.length;
    },
  }
}
</script>

<style lang="scss" scoped>
.cjr-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  &__journey {
    font-weight: 600;
    color: #5e5873;
  }
}

.cjr-empty {
  color: #6e6b7b;
  padding: 8px 0;
}

.dark-layout {
  .cjr-head__journey {
    color: #d0d2d6;
  }

  .cjr-empty {
    color: #b4b7bd;
  }
}
</style>
